import React, { Component } from "react";
import PropTypes from "prop-types";
import CustomSelect from "../../../components/CustomFormFields/CustomSelect";

class WidgetFilterBox extends Component{
    static propTypes = {
        areaFilter: PropTypes.array.isRequired,
        onAreaChange: PropTypes.func.isRequired,
        statusFilter: PropTypes.array.isRequired,
        onStatusChange: PropTypes.func.isRequired,
        selectedAreas: PropTypes.array,
        selectedStatus: PropTypes.any,
        areaFilterLabel: PropTypes.string,
    }

    static defaultProps = {
        areaFilterLabel: "VORSORGEN:"
    }

    render() {
        // Erweiterte areaFilter-Optionen mit "Top 5" Eintrag
        const extendedAreaFilter = [
            { id: 'top5', name: 'Top 5' },
            ...this.props.areaFilter
        ];
        
        // Wert für die Bereichsauswahl, inklusive "Top 5" wenn im Top 5 Modus
        const selectedAreas = this.props.isTop5Mode 
            ? ['top5'] 
            : this.props.selectedAreas;
        
        return (
            <div className="widget-toolbox row">
                <div className="col">
                    <CustomSelect 
                        selectLabel={this.props.areaFilterLabel}
                        optionsList={extendedAreaFilter}
                        onChange={this.props.onAreaChange}
                        value={selectedAreas}
                        multiple={true}
                        placeholder="Bereich auswählen"
                    />
                </div>
                <div className="col-auto d-flex justify-content-center">
                    <CustomSelect 
                        selectLabel="STATUS:"
                        optionsList={this.props.statusFilter}
                        onChange={this.props.onStatusChange}
                        value={this.props.selectedStatus}
                    />
                </div>
            </div>
        )
    }
}
  
export default WidgetFilterBox;
